import React from 'react';

const ReservationsModal = ({ isOpen, onClose }) => {
  // Si isOpen es false, no renderizamos nada
  if (!isOpen) return null;

  // Si isOpen es true, mostramos el modal
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2>Reservations</h2>
        <p>Formulario o contenido para reservar aquí...</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

// Estilos internos
const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};

const modalStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  maxWidth: '500px',
  width: '90%',
};

export default ReservationsModal;
